const Vaaar = 'yyy';
const showToast = (content) => {
    $('#toast-container .toast').remove();

    const toastMessage = $('<div class="toast">');
    const toast = $('<div class="toast-content">').html(content);

    const closeButton = 
        $(`<div class="toast-close">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                    <path id="icons8-cross" d="M5.944,4.293,4.293,5.944l7.349,7.349L4.293,20.642l1.651,1.651,7.349-7.349,7.349,7.349,1.651-1.651-7.349-7.349,7.349-7.349L20.642,4.293l-7.349,7.349Z" transform="translate(-4.293 -4.293)"/>
                </svg>      
            </div>
        `).on("click", function() {
            toastMessage.remove();
        });


    toastMessage.append(toast);
    toastMessage.append(closeButton);

    $('#toast-container').append(toastMessage);

    setTimeout(function() {
        toastMessage.fadeOut(300, function() {
            $(this).remove();
        });
    }, 3500);
}